import { uiText, useUiLanguage } from '../../utils/uiTranslation';
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import SubscriptionPopup from '../applicants/SubscriptionPopup';
import './Trial.css';

const TrialExpiredModal = ({ trial }) => {
  useUiLanguage();
  const { currentUser } = useAuth();
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);

  const expiredDaysAgo = trial?.expiredDaysAgo || 0;

  return (
    <>
      <div className="feature-gate-no-access" style={{ minHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
        <div className="trial-expired-card">
          <div className="trial-expired-icon">
            <i className="fa-solid fa-clock" style={{ fontSize: '48px', color: 'var(--app-tone-ff6b6b, #ff6b6b)' }}></i>
          </div>
          
          <h2 className="trial-expired-title">{uiText("Your Free Trial Has Ended")}</h2>
          
          <p className="trial-expired-message">{uiText("Your 14-day free trial expired")}{expiredDaysAgo > 0 && uiText(" {{count}} days ago", { count: expiredDaysAgo })}.
          </p>

          <p className="trial-expired-cta">{uiText("Subscribe now to regain access to all your data and features!")}</p>

          <div className="trial-expired-features">
            <h3 className="trial-expired-features-title">{uiText("What you'll get:")}</h3>
            <ul>
              <li className="trial-expired-feature-item"><i className="fa-solid fa-check" style={{ color: 'var(--app-tone-51cf66, #51cf66)', marginRight: '8px' }}></i>{uiText(" Access to all your saved data")}</li>
              <li className="trial-expired-feature-item"><i className="fa-solid fa-check" style={{ color: 'var(--app-tone-51cf66, #51cf66)', marginRight: '8px' }}></i>{uiText(" Unlimited job postings")}</li>
              <li className="trial-expired-feature-item"><i className="fa-solid fa-check" style={{ color: 'var(--app-tone-51cf66, #51cf66)', marginRight: '8px' }}></i>{uiText(" Advanced analytics")}</li>
              <li className="trial-expired-feature-item"><i className="fa-solid fa-check" style={{ color: 'var(--app-tone-51cf66, #51cf66)', marginRight: '8px' }}></i>{uiText(" Priority support")}</li>
            </ul>
          </div>

          <div className="trial-expired-actions">
            <button
              onClick={() => setShowSubscriptionPopup(true)}
              className="trial-expired-primary-button"
            >
              <i className="fa-solid fa-rocket" style={{ marginRight: '8px' }}></i>{uiText("Subscribe Now")}</button>
          </div>

          <p className="trial-expired-note">
            <i className="fa-solid fa-info-circle" style={{ marginRight: '6px' }}></i>{uiText("Your data is preserved for 30 days. Subscribe within this time to keep everything.")}</p>
        </div>
      </div>

      {/* Subscription Popup */}
      {showSubscriptionPopup && (
        <SubscriptionPopup
          isOpen={showSubscriptionPopup}
          onClose={() => setShowSubscriptionPopup(false)}
          userUID={currentUser?.uid}
        />
      )}
    </>
  );
};

export default TrialExpiredModal;

